import type { Monitoring } from "./monitoring.ts"

import * as Sentry from "@sentry/react"

export const monitoring: Monitoring = {
  init: (config: Monitoring.Config) => {
    return Sentry.init({
      dsn: config.dsn,
      environment: config.environment,
      tracesSampleRate: 1,
      replaysSessionSampleRate: 0,
      replaysOnErrorSampleRate: 1,

      integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration({
          maskAllInputs: false,
          maskAllText: false,
        }),
      ],
    })
  },
  captureException: (exception: Error, contextData?: Monitoring.ContextData) => {
    Sentry.captureException(exception, { extra: contextData })
  },
}

export const SentryMonitoring = {
  ClientScript: ({ config }: { config: Monitoring.Config }) => (
    <script
      dangerouslySetInnerHTML={{ __html: `window.SENTRY_CONFIG = ${JSON.stringify(config)}` }}
    />
  ),
}

declare global {
  interface Window {
    SENTRY_CONFIG?: Monitoring.Config
  }
}
